import { getOriginalFileName } from "utils/string";

const CertificatesView = ({ data }) => {
  return (
    <div className="card">
      <h5>Certificates 证书</h5>
      <div className="mt-2">
        {!data.certificates || Object.keys(data.certificates).length === 0 ? (
          <div className="opacity-70">No certificates provided.</div>
        ) : (
          <div className="whitespace-nowrap -mx-2">
            <table>
              <tbody>
                {data.certificates &&
                  Object.entries(data.certificates).map(
                    ([key, value], index) => (
                      <tr key={index} className="border-y border-gray-100">
                        <td>
                          <label>{key}: </label>
                        </td>
                        <td className="w-full">
                          {value ? (
                            <a
                              href={value}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="whitespace-normal text-xs"
                            >
                              {getOriginalFileName(value)}
                            </a>
                          ) : (
                            <span className="text-gray-500">Not provided</span>
                          )}
                        </td>
                      </tr>
                    ),
                  )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificatesView;
